<template>
  <div>
    <div class="LinksBlock" :class="{ Edit: showEditLink }" v-show="card.links.length || showEditLink">
      <div class="Zg">Ссылки на другие ресурсы и источники</div>
      <div class="LinkBox" :class="{ Edit: showEditLink }" v-for="(link, index) in card.links">
        <div class="Link"><a :href="link.adr" target="_blank">{{ link.adr }}</a></div>
        <div class="LinkOpisanie">{{ link.txt }}</div>
        <div class="EditBlock" v-if="showEditLink">
          <div class="GearBt" @click="showEditCardLink(index)"></div>
          <div class="DelBt" @click="deleteLink(index)"></div>
        </div>
      </div>
      <div class="AddBlock Links" @click="showAddLink" v-if="showEditLink">ДОБАВИТЬ</br>ССЫЛКУ</div>
    </div>

    <div class="PopUpAdd" id="PopUpL" v-show="editMode">
      <div class="PopUpFon" @click="offEditMode"></div>
      <div class="PopUpPanel">
        <div class="PopUpBlock" style="height: 360px;">
          <div class="PopUpName" style="color: #37bbd6; font-style: bold">{{ editLinkTitle() }}</div>
          <div class="PopUpClose" @click="offEditMode"></div>
          <div class="Rline3"></div>
          <form @submit.prevent="saveLink">
            <input type="text" class="LinkLoad" placeholder="Вставьте ссылку" v-model="editLink().adr"></br>
            <textarea maxlength='120' class='FileOpisForma' placeholder="Описание к ссылке в 120 знаков." v-model="editLink().txt"></textarea>
            <input type="submit" class="BtFileLoad" value="СОХРАНИТЬ">
          </form>
          <!-- <div class="FLError">Ошибка к загрузке ссылки...</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pick } from 'lodash';

export default {
  props: {
    card: { type: Object, default: function() { return {}; } },
    showEditLink: { type: Boolean, default: function() { return false; } },
    saveData: Function
  },
  data() {
    return {
      editMode: false,
      newLink: {},
      editLinkIndex: -1
    };
  },
  methods: {
    onEditMode() {
      this.editMode = true;
      console.log('Card component onEditMode', this.editMode);
    },
    offEditMode() {
      this.editMode = false;
      console.log('Card component offEditMode', this.editMode);
    },
    showAddLink() {
      this.editLinkIndex = -1;
      this.onEditMode();
    },
    showEditCardLink(index) {
      this.editLinkIndex = index;
      console.log('Card component editLink', this.editLink());
      this.onEditMode();
    },
    editLink() {
      return this.editLinkIndex == -1 ? this.newLink : this.card.links[this.editLinkIndex];
      // console.log('editLink link', link);
      // return link;
    },
    editLinkTitle() {
      return this.editFileIndex == -1 ? "ДОБАВИТЬ ССЫЛКУ" : "ИЗМЕНИТЬ ССЫЛКУ";
    },
    saveLink() {
      const link = this.editLink();
      console.log('saveLink', link);

      const links =
        (this.editLinkIndex == -1 ?
           this.card.links.concat([this.newLink]) :
           this.card.links);
      const params = {links: links};
      console.log('updateCardColumns params', params);

      // updateCardParams.call(this, {card: params}, 'link', ['links']);
      this.saveData({card: params}, this.offEditMode, ['links']);
      if (this.editLinkIndex == -1) this.newLink = {};
    },
    deleteLink(index) {
      const links = this.card.links;
      links.splice(index, 1);
      console.log('deleteLink', links);
      const params = {links: links};
      // updateCardParams.call(this, {card: params}, false, ['links']);
      this.saveData({card: params}, false, ['links']);
      this.editLinkIndex = -1;
    },
  }
};
</script>

<style>
.LinksBlock
{
  position: relative;
  margin: 0px auto;
  padding-top: 30px;
  padding-bottom: 30px;
  width: 1200px;
  /* height: 300px; */
  border-top: 1px solid #cccccc;
}

.LinksBlock.Edit{
  padding-bottom: 50px;
}

.LinkBox{
  position: relative;
  margin-left: 60px;
  padding-bottom: 20px;
  width: 850px;
  border: 0px solid #cccccc;
}

.LinkBox.Edit{
  padding-top: 10px;
  padding-bottom: 40px;
}

.Link a{
  font-family: 'Roboto Condensed', sans-serif;
  font-weight: normal;
  font-size: 16px;
  text-align: left;
  padding-bottom: 5px;
}

.LinkOpisanie{
  /* font-family: 'Roboto', sans-serif; */
  font-family: 'Open Sans', sans-serif;
  color: #6d6d6d;
  /* font-style: italic; */
  font-size: 13px;
  text-align: left;
  padding-top: 5px;
  padding-bottom: 10px;
}
</style>
